import {
  Countertops,
  LunchDining,
  MenuBook,
  Person2,
  Restaurant,
  Settings,
  Shop2,
  TableRestaurant,
  Tune,
  Receipt,
} from '@mui/icons-material';
import { DrawerMenuIconType } from './drawerMenuSlice';

interface Props {
  iconType: DrawerMenuIconType;
}

const DrawerMenuIcon = ({ iconType }: Props) => {
  switch (iconType) {
    case DrawerMenuIconType.Kitchens:
      return <Countertops />;
    case DrawerMenuIconType.Restaurants:
      return <Restaurant />;
    case DrawerMenuIconType.Menus:
      return <MenuBook />;
    case DrawerMenuIconType.RestaurantTables:
      return <TableRestaurant />;
    case DrawerMenuIconType.RestaurantUsers:
      return <Person2 />;
    case DrawerMenuIconType.MealItems:
      return <LunchDining />;
    case DrawerMenuIconType.Customizations:
      return <Tune />;
    case DrawerMenuIconType.Orders:
      return <Shop2 />;
    case DrawerMenuIconType.Settings:
      return <Settings />;
    case DrawerMenuIconType.Profile:
      return <Person2 />;
    case DrawerMenuIconType.Receipt:
      return <Receipt />;
    default:
      return null;
  }
};

export default DrawerMenuIcon;
